import get from "lodash.get";
import config from "../config";

export default (key, defaultValue = null) => get(config, key, defaultValue);
